module.exports = __webpack_public_path__ + "img/offer-badge.cbb8b1d3.svg";